
const APP_IMAGE = {
    logo_min: '/images/logo-min.svg',
    default_ads_banner: '/images/banner-ads.jpg'
}

export default APP_IMAGE;